module.exports = __webpack_public_path__ + "static/media/refurbishGardenSlabs.7850cad8.jpg";